(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const form = document.getElementById('CartForm');
    if (!form) return;

    form.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const wrap = btn.closest('.cart-page__qty-controls');
        const input = wrap?.querySelector('input');
        if (!input) return;
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(btn.dataset.qtyChange));
        input.value = String(next);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const nav = document.querySelector('.collection-page__jump-nav');
    if (!nav) return;
    const header = document.querySelector('.site-header');

    let lastTop = null;

    // Pin flush to whatever the header's bottom edge currently is. Using the
    // live rect covers a sticky header, a scrolled-away header, and any
    // announcement bar still on screen above it.
    const update = () => {
      const offset = header
        ? Math.max(0, Math.round(header.getBoundingClientRect().bottom))
        : 0;
      if (offset === lastTop) return;
      lastTop = offset;
      nav.style.top = `${offset}px`;
      document.documentElement.style.setProperty(
        '--jump-nav-offset',
        `${offset + nav.offsetHeight}px`
      );
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.site-header');
  const toggle = document.querySelector('.site-header__menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');

  // Publish measured height so sticky page elements can pin flush beneath the
  // header. Read-only: the header's own height must never depend on this var.
  if (header) {
    const publishHeaderHeight = () => {
      document.documentElement.style.setProperty(
        '--site-header-height',
        `${Math.round(header.getBoundingClientRect().height)}px`
      );
    };
    publishHeaderHeight();
    window.addEventListener('resize', publishHeaderHeight);
  }

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
      mobileNav.hidden = expanded;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-channels"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-open-chat]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const chatway = window.$chatway;
      const ready =
        chatway &&
        (typeof chatway.isChatwayLoaded !== 'function' || chatway.isChatwayLoaded());

      if (ready && typeof chatway.openChatwayWidget === 'function') {
        chatway.openChatwayWidget();
        return;
      }

      // Chatway not installed or still loading — send them to the email form.
      const fallbackTarget = (trigger.dataset.chatFallback || '').trim();
      if (!fallbackTarget) return;

      if (fallbackTarget.startsWith('/') || fallbackTarget.startsWith('http')) {
        window.location.assign(fallbackTarget);
        return;
      }

      const selector = fallbackTarget.startsWith('#') ? fallbackTarget : `#${fallbackTarget}`;
      const fallback = document.querySelector(selector);
      if (fallback) {
        fallback.scrollIntoView({ behavior: 'smooth', block: 'start' });
        fallback.querySelector('input, textarea')?.focus({ preventScroll: true });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
